import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Home/Hero/Hero";
import UpButton from '../../components/UpButton';
//============================================
import styles from "./ErrorPage.module.scss";
import { Helmet } from "react-helmet";
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==

const ErrorPage = ({scroll , lang}) => {
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //--- 
  return (
    <div>
      <Helmet>
        <title>Millensys - 404</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
        <div className={styles["certification_container"]} style={{height:'20vh'}}>
          <div className={styles["title"]}>
            <h3>
            <span>MILLENSYS,</span>Page not found!
            </h3>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ErrorPage;
